import { hotTopics } from "@/mocks/guaData";
import SectionHeading from "./SectionHeading";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line text-accent-500",
  down: "ri-arrow-down-line text-primary-500",
  flat: "ri-subtract-line text-secondary-500",
};

export default function HotRank() {
  return (
    <section id="hot" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <SectionHeading
            kicker="今日热瓜 · 实时热度榜"
            title="今天该吃哪个瓜？看这里"
            desc="按全网讨论热度实时排序，榜单每日滚动更新。高赞神回复与名场面都藏在标题背后的评论区里。"
          />
          <a
            href="#reply"
            className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
          >
            逛神回复专区
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <ol className="mt-8 grid gap-3 md:grid-cols-2">
          {hotTopics.map((t) => (
            <li
              key={t.rank}
              className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-100/60 p-4 transition-all hover:-translate-y-0.5 hover:border-primary-300 hover:bg-background-50"
            >
              <span
                className={`font-heading text-3xl md:text-4xl ${
                  t.rank <= 3 ? "text-accent-500" : "text-background-400"
                }`}
              >
                {String(t.rank).padStart(2, "0")}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="whitespace-nowrap rounded bg-secondary-100 px-1.5 py-0.5 text-xs text-secondary-900">
                    {t.tag}
                  </span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500">
                    <i className={`${trendIcon[t.trend]} text-xs`}></i>
                    {t.heat}
                  </span>
                </div>
                <a href="#reply" className="mt-1.5 block truncate text-sm font-medium text-foreground-800 group-hover:text-primary-700 md:text-base">
                  {t.title}
                </a>
              </div>
              <span className="hidden items-center gap-1 whitespace-nowrap rounded-full border border-background-300 px-2.5 py-1 text-xs text-foreground-500 sm:inline-flex">
                <i className="ri-chat-3-line"></i>
                评论 9999+
              </span>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}